import { ArticleEffect } from './article.effect';
import { ArticlesEffects } from './articles.effects';

export const effects: any[] = [ArticlesEffects, ArticleEffect];
